import React from "react";
import { Tooltip } from 'react-tooltip';
//components
import Text from "components/Text";
import { Visibility } from "components/Visibility";
import { Column, Row } from "components/Layout/Grid";
//models
import { IReportIndicator } from "../models/reportIndicator";
//assets
import downloadTechnicalSheetBtn from "img/download-technical-sheet.svg";
//utils
import { generateRandomId } from "utils/GenerateRandomId";
//styles
import "../../styles.scss";
import { colors } from "pages/Quotes/styles/colors";

const ReportLayoutIndicator: React.FC<IReportIndicator> = ({
  data,
  onClick,
  tooltipContent,
  tooltipPlace,
}) => {
  const { title, value, image, imageVisibility } = data;

  const reactTooltipId = generateRandomId("ReactTooltipReport");

  return (
    <>
      <div
        data-tooltip-content={tooltipContent || "Clique para baixar"}
        data-tooltip-id={reactTooltipId}
        data-tooltip-place={tooltipPlace || "top"}
        className="mt-6 mb-3 indicators flex-row"
        style={{ minWidth: '330px' }}
      >
        <Row
          className="bg-white mr-md-0 indicator indicator-report flex-1"
          style={{ minWidth: '330px' }}
          onClick={onClick || undefined}
        >
          <Visibility visible={!!imageVisibility}>
            <Column className="indicator-img">
              <img src={image} />
            </Column>
          </Visibility>
          <Column className="flex-1 justify-center">
            <Column className="title-subtitle">
              <Text size={16} className="title color-blueDark font-bold">
                {title}
              </Text>
              <Visibility visible>
                <Text size={32} className="pp-text-uppercase font-bold value" color={colors.blueViveo}>
                  {value}
                </Text>
              </Visibility>
            </Column>
          </Column>
          <Visibility visible>
            <Column className="justify-end">
              <img src={downloadTechnicalSheetBtn} />
            </Column>
          </Visibility>
        </Row>
      </div>

      <Visibility visible={!!data}>
        <Tooltip className="z-999-important" id={reactTooltipId} variant='light' />
      </Visibility>
    </>
  );
};

export default ReportLayoutIndicator;
